/**
 * IDB-backed React Query persister.
 *
 * Persists query cache to IndexedDB so data survives:
 * - Tab close / reopen (instant load, no skeleton)
 * - Offline mode (full work day without signal — ADR-037)
 * - Cold start (IDB hydrates before first API call)
 *
 * Uses idb-keyval for simple key-value storage.
 * maxAge: 24 hours (covers early start + late finish + next morning cold start).
 */

import { get, set, del } from 'idb-keyval'
import type { PersistedClient, Persister } from '@tanstack/react-query-persist-client'

const IDB_KEY = 'appic-react-query-cache'

export const idbPersister: Persister = {
  persistClient: async (client: PersistedClient) => {
    await set(IDB_KEY, client)
  },
  restoreClient: async () => {
    return await get<PersistedClient>(IDB_KEY) ?? undefined
  },
  removeClient: async () => {
    await del(IDB_KEY)
  },
}

/** 24 hours — covers full work day + next morning cold start (ADR-037) */
export const CACHE_MAX_AGE = 24 * 60 * 60 * 1000
